import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';

import { CurrencyInput } from 'src/common/CurrencyInput';
import {
  FormFieldController,
  FormFieldControllerRulesProps,
} from 'src/common/FormField/FormFieldController';

export function CurrencyFormContextField({
  fieldPath,
  rules,
  disabled,
  label,
  inline,
  helperText,
}: {
  fieldPath: string;
  rules?: FormFieldControllerRulesProps;
  disabled?: boolean;
  label: string;
  inline?: boolean;
  helperText?: string;
}) {
  return (
    <FormFieldController name={fieldPath} rules={rules}>
      {({ field, fieldState }) => {
        const { onChange, ...remainingProps } = field;
        return (
          <DefaultFormFieldLayout
            label={rules?.required ? `${label} *` : label}
            error={fieldState.error?.message?.toString()}
            inputId={fieldPath}
            inline={inline}
            helperText={helperText}
          >
            <div className="relative flex items-center gap-2">
              <CurrencyInput
                id={fieldPath}
                {...remainingProps}
                disabled={disabled}
                onValueChange={(values) => {
                  // Variable name floatValue is misleading
                  // This is actually resolved as an cents/integer in form values
                  field.onChange(values.floatValue);
                }}
              />
            </div>
          </DefaultFormFieldLayout>
        );
      }}
    </FormFieldController>
  );
}
